<%# Subscribe to real-time clip updates %>
<%= turbo_stream_from "clips" %>

<div class="container mx-auto px-4 py-8" data-controller="dictaphone">
  <h1 class="text-3xl font-bold mb-2">Dictaphone</h1>
  <p class="text-gray-600 mb-8">Record audio, get automatic transcriptions powered by Whisper AI, and translate to Spanish.</p>

  <!-- Model loading status -->
  <div data-dictaphone-target="status" class="mb-6 p-4 bg-blue-50 text-blue-800 rounded-lg">
    Loading Whisper model...
  </div>

  <!-- Recording controls -->
  <div class="mb-8 p-6 bg-gray-100 rounded-lg">
    <div class="flex gap-4 items-center mb-4">
      <button data-dictaphone-target="record"
              data-action="click->dictaphone#toggleRecording"
              disabled
              class="bg-red-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-red-700 transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
        <span data-dictaphone-target="recordIcon">&#9679;</span>
        <span data-dictaphone-target="recordLabel">Record</span>
      </button>

      <!-- Recording timer -->
      <span data-dictaphone-target="timer" class="text-2xl font-mono text-gray-600 hidden">
        00:00
      </span>

      <!-- Audio level visualizer -->
      <div data-dictaphone-target="visualizer" class="flex-1 h-8 bg-gray-200 rounded hidden">
        <div data-dictaphone-target="level" class="h-full bg-green-500 rounded transition-all duration-100" style="width: 0%"></div>
      </div>
    </div>

    <!-- Playback and save form (shown after recording) -->
    <div data-dictaphone-target="preview" class="hidden">
      <audio data-dictaphone-target="audio" controls class="w-full mb-4"></audio>

      <div data-dictaphone-target="transcribing" class="mb-4 p-3 bg-yellow-50 text-yellow-800 rounded hidden">
        Transcribing audio...
      </div>

      <%= form_with url: clips_path, method: :post,
                    data: { dictaphone_target: "form", action: "submit->dictaphone#save" },
                    class: "space-y-4" do |f| %>
        <input type="hidden" name="clip[duration]" data-dictaphone-target="duration">
        <%# Note: audioData target kept for resetUI compatibility %>
        <input type="hidden" data-dictaphone-target="audioData">

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Name</label>
          <input type="text" name="clip[name]"
                 data-dictaphone-target="name"
                 placeholder="My recording"
                 class="w-full border rounded-lg p-3">
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Transcript</label>
          <textarea name="clip[transcript]"
                    data-dictaphone-target="transcript"
                    rows="4"
                    placeholder="Transcription will appear here..."
                    class="w-full border rounded-lg p-3"></textarea>
        </div>

        <div data-dictaphone-target="translating" class="mb-4 p-3 bg-purple-50 text-purple-800 rounded hidden">
          Translating to Spanish...
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Translation (Spanish)</label>
          <textarea name="clip[translation]"
                    data-dictaphone-target="translation"
                    rows="4"
                    placeholder="Translation will appear here..."
                    class="w-full border rounded-lg p-3"></textarea>
        </div>

        <div class="flex gap-4">
          <%= f.submit "Save Clip",
                 class: "bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700 transition cursor-pointer" %>
          <button type="button"
                  data-action="click->dictaphone#discard"
                  class="bg-gray-400 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-500 transition">
            Discard
          </button>
        </div>
      <% end %>
    </div>
  </div>

  <!-- Clips list -->
  <div>
    <h2 class="text-xl font-semibold mb-4">Your Clips</h2>
    <div id="clips" class="space-y-4">
      <%= render @clips %>
      <p id="empty-message" class="text-gray-500 text-center py-12 hidden only:block">
        No clips yet. Record something to get started!
      </p>
    </div>
  </div>
</div>
